
import { BaseService } from "../BaseService";
import { NoseurObject } from "@ronuse/noseur";

export interface IFaq {
    title: string;
    content: string;
    external_id: string;
    platform_id: string;
}

export class FaqService extends BaseService {

    protected static instance: FaqService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!FaqService.instance) FaqService.instance = new FaqService();
        return FaqService.instance;
    }

    queryFaqs(query: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/hera/api/v1/faq", { cache: true, query: this.normalizeParams(query) }));
    }

}
